import * as React from 'react';

const LogoEBurstSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 61 61" {...props}>
        <defs>
            <circle
                id="logo-e-burst_svg__path-3"
                cx={30.5}
                cy={30.5}
                r={28.5}
            />
            <circle
                id="logo-e-burst_svg__path-7"
                cx={30.5}
                cy={30.5}
                r={28.5}
            />
            <path id="logo-e-burst_svg__path-1" d="M0 0h61v61H0z" />
            <path id="logo-e-burst_svg__path-5" d="M0 0h61v61H0z" />
        </defs>
        <g
            id="logo-e-burst_svg__Page-1"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g id="logo-e-burst_svg__logo-e-burst">
                <g id="logo-e-burst_svg__logo-e-burst-Oval-3-Clipped">
                    <mask id="logo-e-burst_svg__mask-2" fill="#fff">
                        <use xlinkHref="#logo-e-burst_svg__path-1" />
                    </mask>
                    <path
                        d="M30.5 59C46.24 59 59 46.24 59 30.5S46.24 2 30.5 2 2 14.76 2 30.5 14.76 59 30.5 59z"
                        id="logo-e-burst_svg__logo-e-burst-Oval-3"
                        stroke="#F6682F"
                        strokeWidth={4}
                        strokeDasharray="1,2.5"
                        mask="url(#logo-e-burst_svg__mask-2)"
                    />
                    <mask id="logo-e-burst_svg__mask-4" fill="#fff">
                        <use xlinkHref="#logo-e-burst_svg__path-3" />
                    </mask>
                </g>
                <g id="logo-e-burst_svg__logo-e-burst-Oval-4-Clipped">
                    <mask id="logo-e-burst_svg__mask-6" fill="#fff">
                        <use xlinkHref="#logo-e-burst_svg__path-5" />
                    </mask>
                    <path
                        d="M30.5 59C46.24 59 59 46.24 59 30.5S46.24 2 30.5 2 2 14.76 2 30.5 14.76 59 30.5 59z"
                        id="logo-e-burst_svg__logo-e-burst-Oval-4"
                        stroke="#F6682F"
                        strokeWidth={4}
                        strokeDasharray="1,2.5"
                        mask="url(#logo-e-burst_svg__mask-6)"
                    />
                    <mask id="logo-e-burst_svg__mask-8" fill="#fff">
                        <use xlinkHref="#logo-e-burst_svg__path-7" />
                    </mask>
                </g>
                <path
                    d="M28.756 22.215c3.62-.784 7.233.636 9.244 3.322L22 29c.552-3.24 3.135-6.002 6.756-6.785zM37.9 35.192c-1.22 1.697-3.098 2.98-5.39 3.477-3.671.796-7.335-.662-9.354-3.407l16.172-3.507 2.635-.571L47 30.092a14.688 14.688 0 00-.42-3.078c-2.05-8.34-10.91-13.539-19.788-11.613-8.88 1.925-14.415 10.246-12.365 18.585 2.05 8.34 10.91 13.539 19.788 11.613 5.232-1.134 9.302-4.49 11.344-8.76L37.9 35.192z"
                    id="logo-e-burst_svg__logo-e-burst-Fill-1"
                    fill="#F6682F"
                    fillRule="nonzero"
                />
            </g>
        </g>
    </svg>
);

LogoEBurstSvg.displayName = 'LogoEBurstSvg';
export default LogoEBurstSvg;
